/**
 * Responsible for creating navigation styling based on elements existing in the DOM
 * @module navActive
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

var PLUGIN_NAME = 'navActive';
var MOUSEENTER_EVENT = 'mouseenter';
var MOUSELEAVE_EVENT = 'mouseleave';
var LINK_CLASS = '.js-nav-primary__link'

var DEFAULTS = {

};

// Expose the function as a jQuery plugin for ease of use
registerJQueryPlugin(PLUGIN_NAME, navActive);


/**
 * Initializes navigation styling based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * active and inactive navigation
 * @param {Object} options - Options used for wiring up the navigation
 * @see DEFAULTS
 */
export default function navActive(el, options = {}) {
  var $el = $(el);
  var opts = mergeOptions(DEFAULTS, options, $el)

  applyEventHandlers($el, opts);
}

/**
 * Applies any sort of event handlers for the toggleContent.
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function applyEventHandlers($el, opts) {
  opts = opts || {};

  $el
    .on(MOUSEENTER_EVENT, function(evt){
      itemMouseEnterHandler(evt, $el, opts)
    });

  $el
    .on(MOUSELEAVE_EVENT, function(evt){
      itemMouseLeaveHandler(evt, $el, opts)
    });

}

/**
 * Handles the mouseenter event when an element has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} opts - Options passed along from initialization
 */
function itemMouseEnterHandler(e, $el) {

  var $this = $($el);
  var $childlink = $this.children(LINK_CLASS);

  $(LINK_CLASS).not($childlink).addClass('inactive');
  $childlink.removeClass('inactive').addClass('active');
}

/**
 * Handles the mouseleave event when an element has been iteracted with.
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the toggleContent
 * @param {Object} opts - Options passed along from initialization
 */
function itemMouseLeaveHandler(e, $el) {

  var $this = $($el);
  $(LINK_CLASS).removeClass('active inactive');

}



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/nav-active.js